import { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Asset, Box } from '@altermaind/web/ui';
import { getModeTheme } from '@/_shared/styles/state/selectors';

type Props = {
  children: ReactElement;
};

export const UnauthenticatedPageLayout: FC<Props> = ({ children }) => {
  const mode = useSelector(getModeTheme());

  return (
    <Box
      bg='primary/background'
      height='100vh'
      width='100vw'
      flexDirection='column'
      display='flex'
      alignItems='center'
    >
      <Box
        minHeight='100vh'
        display='flex'
        flex='0 0 auto'
        alignItems='center'
        justifyContent='center'
        flexDirection='column'
      >
        <Asset
          mb='xl'
          domain='images'
          name={mode === 'light' ? 'logoLight' : 'logoDark'}
          width='150'
        />
        {children}
      </Box>
    </Box>
  );
};
